import style from '../TaskActions.module.scss';

import { Button, ButtonTheme } from '@components/Button';
import { CommonTestAttributes } from 'chaika-test-attributes';

interface Props {
    disabled?: boolean;
    theme: ButtonTheme;
    label: string;
    dataTest?: string;
    onClick(): void;
}

export function TaskAction({ disabled, theme, label, dataTest, onClick }: Props): React.ReactElement<any> {
    return (
        <Button
            additionaClassNames={[style.action]}
            disabled={disabled}
            theme={theme}
            label={label}
            onClick={onClick}
            dataTest={dataTest ?? CommonTestAttributes.Unknown}
        />
    );
}
